module.exports = __webpack_public_path__ + "static/media/Mr.Keyaar6-1-2022-.f2de3600.jpg";